import { useSearch } from '@tanstack/react-router';
import { getKeycloak } from '@/auth/keycloak-instance';
import { loginRedirectUri } from '@/auth/return-path';
import eurecaWordmark from './eureca-wordmark.svg';

function GoogleIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="h-4 w-4 shrink-0"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}

export default function LoginPage() {
  // EU-756 (OKR-003): volta para a rota que o visitante pediu (`?redirect=`),
  // não para a raiz. Sem destino seguro, cai na home como antes.
  const { redirect: returnTo } = useSearch({ from: '/login' });
  const redirectUri = loginRedirectUri(returnTo);

  function handleGoogleLogin() {
    getKeycloak().login({
      idpHint: 'google',
      redirectUri,
    });
  }

  // Sem idpHint: cai na tela hospedada do Keycloak (e-mail/senha + Google +
  // link de cadastro) — necessário para contas fora do Google (e.g. Zoho).
  function handlePasswordLogin() {
    getKeycloak().login({
      redirectUri,
    });
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-8 py-8">
      <div className="flex w-full max-w-[640px] flex-col gap-16">
        <img src={eurecaWordmark} alt="Eureca" className="h-8 w-auto self-start" />

        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <h1 className="text-5xl font-semibold leading-none tracking-tight text-foreground">
              Login
            </h1>
            <p className="text-base leading-6 text-muted-foreground">
              Boas-vindas! Faça login com a sua conta Google ou com e-mail e senha para começar.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <button
              type="button"
              onClick={handleGoogleLogin}
              data-testid="recruiter-login-google"
              className="flex h-10 w-[304px] shrink-0 items-center justify-center gap-2 rounded-lg border border-input bg-background px-6 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Entrar com Google
              <GoogleIcon />
            </button>

            <button
              type="button"
              onClick={handlePasswordLogin}
              data-testid="recruiter-login-password"
              className="flex h-10 w-[304px] shrink-0 items-center justify-center gap-2 rounded-lg border border-input bg-background px-6 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Entrar com e-mail e senha
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
